import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/CurrencyYenCircleFill.tsx
const CurrencyYenCircleFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm1.475 5L12 10.89 10.525 7H8l2.27 5.272H8.496V13.7h2.234v.7H8.496v1.427h2.234V18h2.467v-2.173h2.03V14.4h-2.03V13.7h2.03v-1.428h-1.512L16 7h-2.525Z",
		fill: props.fill || "currentColor"
	})
}));
export { CurrencyYenCircleFillIcon };
